import { useRef, useEffect } from 'react';
import { State } from 'react-native-gesture-handler';


const readableState = {
  [State.ACTIVE]: 'ACTIVE',
  [State.UNDETERMINED]: 'UNDETERMINED',
  [State.FAILED]: 'FAILED',
  [State.BEGAN]: 'BEGAN',
  [State.CANCELLED]: 'CANCELLED',
  [State.ACTIVE]: 'ACTIVE',
  [State.END]: 'END',
};


export const logHandlerEvent = (name, { nativeEvent }) => {
  console.log(`${name}: ${readableState[nativeEvent.state]}`, nativeEvent);
};

export function usePrevious(value) {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
}

export default { logHandlerEvent, usePrevious };
